module.exports = __webpack_public_path__ + "img/Gruppenführer_R.bc00f434.svg";